import { render, staticRenderFns } from "./call.vue?vue&type=template&id=75a4b540&scoped=true&"
import script from "./call.js?vue&type=script&lang=js&"
export * from "./call.js?vue&type=script&lang=js&"
import style0 from "./call.css?vue&type=style&index=0&id=75a4b540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a4b540",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
